import React from "react";
import { Link } from "react-router-dom";  // Use Link for navigation
import Layout from "../components/Layout/Layout";


const ReleaseNotesCard = () => {
    return (
        <Layout>
            <div className="release-notes-container">
                <header className="release-header">
                    <h1 className="marginBottom10px">Finnkoda Releases</h1>
                    <h2>Finnkoda Web Application</h2>
                </header>

                <section className="overview-section">
                    <p>Finnkoda release notes are specific to each version of the application. Select your version from the list below to see the release notes for it.</p>

                    {/* Manually rendering version links */}
                    <div style={{ display: "flex", gap: "20px", padding: "10px", marginTop: "20px" }}>

                        <Link
                            to="/release/2.1"
                            style={{
                                textDecoration: "none",
                                color: "#1a7d3b",
                                fontSize: "18px",
                                fontWeight: "bold"
                            }}
                        >
                            2.1
                        </Link>
                    </div>
                    <div style={{ display: "flex", gap: "20px", padding: "10px", marginTop: "20px" }}>

                        <Link
                            to="/release/2.0"
                            style={{
                                textDecoration: "none",
                                color: "#1a7d3b",
                                fontSize: "18px",
                                fontWeight: "bold"
                            }}
                        >
                            2.0
                        </Link>
                    </div>
                    <div style={{ display: "flex", gap: "20px", padding: "10px", borderWidth: "1px 0px 0px 0px", borderColor: "#d2d4d2", borderStyle: "solid" }}>


                        <Link
                            to="/release/1.0"
                            style={{
                                textDecoration: "none",
                                color: "#1a7d3b",
                                fontSize: "18px",
                                fontWeight: "bold"
                            }}
                        >
                            1.0
                        </Link>
                    </div>
                    <div style={{ display: "flex", gap: "20px", padding: "10px", borderWidth: "1px 0px 0px 0px", borderColor: "#d2d4d2", borderStyle: "solid" }}>

                        <Link
                            to="/release/0.1"
                            style={{
                                textDecoration: "none",
                                color: "#1a7d3b",
                                fontSize: "18px",
                                fontWeight: "bold"
                            }}
                        >
                            0.1
                        </Link>
                    </div>
                </section>
            </div>
        </Layout>
    );
};

export default ReleaseNotesCard;
